import styled from 'styled-components';

export const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  animation: rendering 0.5s ease-in-out;
`;
